import { createQueryKeyStore } from '@lukemorales/query-key-factory'
import { useQuery } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query'

import { query_audit_logs } from './audit_graphql.ts'

export const keys = createQueryKeyStore({
  audit: {
    logs: (filters: AuditLogFilters) => ({
      queryKey: [filters],
    }),
  },
})

export type AuditLogFilters = {
  limit?: number
  severity?: string
  start_date?: string
  end_date?: string
  user_id?: string
}

export type AuditLog = {
  id: string
  action: string
  description: string
  severity: string
  ip_address: string
  user_id: string
  tags: string[]
  references: string[]
  created_at: string
  updated_at: string
  user?: {
    id: string
    email?: string
    name?: string
    image?: string
    roles?: string[]
    uuid: string
  }
}

export type AuditLogResults = AuditLog[]

export function useAuditLogs(filters: AuditLogFilters = {}) {
  return useQuery<AuditLogResults | null>({
    queryKey: keys.audit.logs(filters).queryKey,
    queryFn: async () => {
      const result = await graphql_admin_call({
        query: query_audit_logs,
        variables: filters,
      })
      return result as AuditLog[]
    },
    staleTime: 0, // Always consider data stale to trigger refetch
    gcTime: 5 * 60 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true, // Always refetch when component mounts
  })
}
